<div class="topbar-item d-none d-sm-flex">
  <button (click)="toggleTheme()" class="topbar-link" type="button">
    <i class="fa fa-moon-o"></i>
    <i class="fa fa-sun-o"></i>
  </button>
</div>
